export * from './loyalty-double-button-widget.styled.default';
